import { render, staticRenderFns } from "./InsMenuItem.vue?vue&type=template&id=7f0e9e08&scoped=true&"
import script from "./InsMenuItem.vue?vue&type=script&lang=ts&"
export * from "./InsMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./InsMenuItem.vue?vue&type=style&index=0&id=7f0e9e08&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0e9e08",
  null
  
)

export default component.exports